import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-100 py-4 sm:py-8" }
const _hoisted_2 = { class: "w-full max-w-sm sm:max-w-md mx-auto bg-white rounded-lg shadow-lg p-4 sm:p-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionDisplay = _resolveComponent("QuestionDisplay")!
  const _component_NavigationButtons = _resolveComponent("NavigationButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-6 text-center" }, " Travel Companion ", -1)),
      _createVNode(_component_QuestionDisplay),
      _createVNode(_component_NavigationButtons)
    ])
  ]))
}